import React from 'react'

interface RightArrowIconProps {
  className?: string
  stroke?: string
}

export const RightArrowIcon: React.FC<RightArrowIconProps> = ({
  className = 'size-4 md:size-[19px]',
  stroke = 'black',
}) => (
  <svg
    className={className}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.10547 4.00006L14.4997 9.14907L9.10547 14.2981"
      stroke={stroke}
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4999 9.14917L4 9.14917"
      stroke={stroke}
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
